import client from './axios'

export type Avatar = {
  url: string | null
}

export async function getAvatar(
  userId: number,
  size?: number,
  signal?: AbortSignal,
): Promise<Avatar> {
  const { data } = await client.get(`/avatars/${userId}`, {
    params: size ? { size } : undefined,
    signal,
  })

  return data
}
